import { Fragment } from 'react'

import { Grid } from '../../components/Base/Base'
import { FlexBox } from '../../components/Base/FlexBox'
import { Box } from '../../components/Box/Box'
import { InfoTooltip, InfoTooltipParagraph } from '../../components/InfoTooltip/InfoTooltip'
import { Text } from '../../components/Text/Text'
import { HandlerOf } from '../../helpers/typeHelper'
import { groupSafetyViolations, SafetyViolation } from '../../models/safety'
import { black, lightGray1, midGray, primaryBlack } from '../../theme/colors'
import { SafetyDashboardCardArrow, SafetyDashboardCardWithIcon } from './SafetyDashboard.styles'
import { SafetyDashboardNewViolationsLabel } from './SafetyDashboardNewViolationsLabel'

interface SafetyDashboardViolationsSummaryProps {
  onViolationClick?: HandlerOf<string>
  violations: SafetyViolation[]
}

export function SafetyDashboardViolationsSummary({
  onViolationClick,
  violations,
}: SafetyDashboardViolationsSummaryProps) {
  const groupedSafetyViolations = groupSafetyViolations(violations)

  return (
    <>
      <Text variant="uppercaseLabel2" mb={1} fontColor={black}>
        Violation categories by total weight
        <InfoTooltip>
          <InfoTooltipParagraph>
            This list shows your fleet's total severity weight in 5 FMCSA violation categories. The FMCSA
            scores violations on a 10-point scale based on crash risk. A higher violation severity weight
            negatively affects your safety score in that category.
          </InfoTooltipParagraph>
        </InfoTooltip>
      </Text>

      {groupedSafetyViolations.map((group, i) => (
        <Fragment key={group.basic}>
          <Box mt={i === 0 ? 0 : 2} />
          <SafetyDashboardCardWithIcon
            onClick={group.violations.length ? () => onViolationClick?.(group.basic) : undefined}
          >
            <Grid columns="1fr 1fr" xsColumns="1.5fr 1fr" gap="10px">
              <Text variant="header3" fontColor={primaryBlack}>
                {group.basicName}
              </Text>
              <div>
                <FlexBox justifyContent="space-between" alignItems="center">
                  <Text variant="header3" fontColor={midGray}>
                    {group.totalWeight || (
                      <Text variant="label3" fontColor={lightGray1} mt={0.3}>
                        No violations
                      </Text>
                    )}
                  </Text>
                  {group.hasNewViolations && (
                    <Box mt={-0.5}>
                      <SafetyDashboardNewViolationsLabel />
                    </Box>
                  )}
                </FlexBox>
              </div>
            </Grid>
            {group.violations.length ? <SafetyDashboardCardArrow /> : null}
          </SafetyDashboardCardWithIcon>
        </Fragment>
      ))}
    </>
  )
}
